/* eslint-disable jsx-a11y/alt-text */
import moment from "moment";

// import "./PurchaseRequisitionReport.css";

import React, { Component } from "react";

export default class PurchaseRequisitionReport extends Component {
  // eslint-disable-next-line no-useless-constructor

  render() {
    const { headers } = this.props;

    return (
      <div className="contentPrint">
        <table>
          <thead>
            <tr>
              <th className="headerNoneBG01" align="left">
                <div className="headerPage">
                  <div className="headerLeft">
                    <img
                      height={80}
                      src={`${process.env.PUBLIC_URL}/images/jaspal-logo.png`}
                    />
                  </div>
                  <div className="headerCenter">
                    <div>
                      <p className="headerTitle">Purchase Requisition</p>
                    </div>
                    <div>
                      <p className="headerTitle">ใบขอซื้อ</p>
                    </div>
                  </div>
                  <div className="headerRight">
                    <div>
                      <p className="headerTitleRight">
                        Update Date :
                        {moment
                          .utc(headers.UPDATED_AT)
                          .local("Asia/Bangkok")
                          .format("DD-MM-yyyy")}
                      </p>{" "}
                    </div>
                    <div>
                      <p className="headerTitleRight">
                        PR No : {headers.PR_NO}
                      </p>
                      <p className="headerTitleRight">
                        Ref Code :{" "}
                        {headers.REF_PR_NO ? headers.REF_PR_NO : "N/A"}
                      </p>
                      <p className="headerTitleRight">{headers.PRINT_TYPE}</p>
                    </div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </table>
        <table className="tableContent">
          <thead>
            <tr className="tableHeader01">
              <th colSpan={9} align="left">
                <p className="titleSection">
                  Part 1: Requester/สำหรับผู้ขอซื้อ
                </p>
              </th>
            </tr>
            <tr className="tableHeaderNoneBG">
              <th colSpan={9} align="left">
                <p className="titleSection">Entity/บริษัท: {headers.COMPANY}</p>
              </th>
            </tr>
          </thead>
        </table>
        <table>
          <thead>
            <tr className="tableHeaderNoneBG02">
              <th className="headerNoneBG02">
                <p className="headerTitle02">Requester/ผู้ขอซื้อ:</p>
                <p className="headerTitle02">{headers.REQUESTER}</p>
              </th>
              <th className="headerNoneBG02">
                <p className="headerTitle02">Brand/แบรนด์:</p>
                <p className="headerTitle02">
                  {headers.BRAND_NAME ? headers.BRAND_NAME : ""}
                </p>
              </th>
              <th className="headerNoneBG02">
                <p className="headerTitle02">BU/หน่วยงาน:</p>
                <p className="headerTitle02">{headers.DEPARTMENT}</p>
              </th>
              <th className="headerNoneBG02">
                <p className="headerTitle02">E-mail/อีเมล์:</p>
                <p className="headerTitle02">{headers.EMAIL}</p>
              </th>
              <th className="headerNoneBG02">
                <p className="headerTitle02">Tel/เบอร์ติดต่อ:</p>
                <p className="headerTitle02"></p>
              </th>
            </tr>
          </thead>
        </table>
        <table className="tableContentDetail">
          <tbody>
            <tr className="rowHeaderNoneBg">
              <td align="center">
                <p className="headerTitle02">No.</p>
              </td>
              <td align="center" width="45%">
                <p className="headerTitle02">Description</p>
              </td>
              <td align="center">
                <p className="headerTitle02">Qty</p>
              </td>
              <td align="center">
                <p className="headerTitle02">U/M</p>
              </td>
              <td align="center">
                <p className="headerTitle02">Unit Price</p>
              </td>
              <td align="center">
                <p className="headerTitle02">Total</p>
                <p className="headerTitle02">Amount</p>
                <p className="headerTitle02">(THB)</p>
              </td>
              <td align="center">
                <p className="headerTitle02">Budget</p>
                <p className="headerTitle02">Amount</p>
                <p className="headerTitle02">(THB)</p>
              </td>
              <td align="center">
                <p className="headerTitle02">Delivery To</p>
              </td>
              <td align="center">
                <p className="headerTitle02">PO No.</p>
              </td>
            </tr>
            <tr className="rowHeaderNoneBg">
              <td align="center">
                <p className="headerTitle02">1</p>
              </td>
              <td align="left" width="45%">
                <p className="headerTitle02">
                  610006 / ExERental1:610006 Machine&EquipRentalnull SALES
                  DEPARTMENT / LA
                </p>
              </td>
              <td align="center">
                <p className="headerTitle02">1</p>
              </td>
              <td align="center">
                <p className="headerTitle02">Pcs.</p>
              </td>
              <td align="center">
                <p className="headerTitle02">10,000.00</p>
              </td>
              <td align="center">
                <p className="headerTitle02">10,000.00</p>
              </td>
              <td align="center">
                <p className="headerTitle02">10,000.00</p>
              </td>
              <td align="center">
                <p className="headerTitle02">MAIN</p>
              </td>
              <td align="center" width="10%">
                <p className="headerTitle02"></p>
              </td>
            </tr>
            <tr className="rowHeaderNoneBg">
              <td align="left" rowSpan={2} colSpan={3}>
                <p className="headerTitle02">
                  * กรณีส่งสินค้านำเข้า
                  ต้องระบุประมาณการค่าใช้จ่ายในการนำเข้าด้วย
                  โดยประสานงานกับหน่วยงาน ImportExport
                </p>
                <p className="headerTitle02">
                  * กรณีสั่งสินค้าที่เป็นทรัพย์สิน
                  ต้องระบุชื่อผู้ถือครองทุกครั้ง
                </p>
              </td>
              <td align="center" colSpan={3}>
                <p className="headerTitle02">Total Expense</p>
              </td>
              <td align="left">
                <p className="headerTitle02">0.00</p>
              </td>
              <td align="center">
                <p className="headerTitle02"></p>
              </td>
              <td align="center">
                <p className="headerTitle02"></p>
              </td>
            </tr>
            <tr className="rowHeaderNoneBg">
              <td align="center" colSpan={2}>
                <p className="headerTitle02">Total Amount</p>
              </td>
              <td align="left">
                <p className="headerTitle02">10,000.00</p>
              </td>
              <td align="center">
                <p className="headerTitle02">10,000.00</p>
              </td>
              <td align="left">
                <p className="headerTitle02">Excluded VAT</p>
              </td>
              <td align="center">
                <p className="headerTitle02"></p>
              </td>
            </tr>
            <tr className="rowHeaderNoneBg">
              <td align="left" colSpan={9}>
                <p className="headerTitle02">
                  Remark/หมายเหตุ: Test Print Out Form
                </p>
              </td>
            </tr>
            <tr className="tableHeader01">
              <td align="left" colSpan={9}>
                <p className="headerTitle02">
                  Part 2:BU Requester/สำหรับหน่วยงานที่ขอซื้อ
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr className="rowHeaderNoneBg">
              <td align="center" width="33.3%">
                <p className="signTitle">ลงชื่อ Paksupa Kapanya</p>
                <p className="signTitle">ตำแหน่ง</p>
                <p className="signTitle">DOA Level: 0</p>
                <p className="signTitle">วันที่ 16-09-2021 16:51:49</p>
                <p className="signTitle">Requester By/จัดทำโดย</p>
              </td>
              <td align="center" width="33.3%">
                <p className="signTitle">ลงชื่อ Paksupa Kapanya</p>
                <p className="signTitle">ตำแหน่ง</p>
                <p className="signTitle">DOA Level: 0</p>
                <p className="signTitle">วันที่ 16-09-2021 16:51:49</p>
                <p className="signTitle">Reviewed By/ผู้ตรวจสอบ</p>
              </td>
              <td align="center" width="33.3%">
                <p className="signTitle">ลงชื่อ Paksupa Kapanya</p>
                <p className="signTitle">ตำแหน่ง</p>
                <p className="signTitle">DOA Level: 0</p>
                <p className="signTitle">วันที่ 16-09-2021 16:51:49</p>
                <p className="signTitle">Approved By/ผู้อนุมัติ</p>
                <p className="signTitle">
                  Delegate From.................................
                </p>
              </td>
            </tr>
            <tr className="tableHeader01">
              <td align="left" colSpan={3}>
                <p className="headerTitle02">
                  Part 3:Procument Depts./สำหรับฝ่ายจัดซื้อ
                </p>
              </td>
            </tr>
            <tr className="rowHeaderNoneBg">
              <td align="left" colSpan={2}>
                <p className="signTitle">
                  ลงชื่อเจ้าหน้าที่จัดซื้อ
                  ..............................................................................
                </p>
              </td>
              <td align="left">
                <p className="signTitle">
                  วันที่
                  .........................................................................
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
